import { createRoot } from 'react-dom/client';
import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { ReactRelayContext } from 'react-relay/legacy.js';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import * as tracking from 'dibs-tracking';

import GetHelpEmbeddedWrapper from '../contact/GetHelpEmbeddedWrapper.tsx';
import ContactHelpArticles from '../contact/ContactHelpArticles.tsx';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.js';
import ContactHeaderCopy from '../contact/ContactHeaderCopy.tsx';

import styles from '../styles/contact.scss';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));
const root = createRoot(document.getElementById('contact-root') as HTMLElement, {
    identifierPrefix: 'contactLanding',
});

initializeDBL().then(() => {
    root.render(
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <ReactRelayContext
                value={{
                    environment,
                }}
            >
                <div className={styles.container}>
                    <div className={styles.contactForm}>
                        <ContactHeaderCopy />
                        <GetHelpEmbeddedWrapper />
                    </div>
                    <div className={styles.helpArticles}>
                        <ContactHelpArticles />
                    </div>
                </div>
            </ReactRelayContext>
        </IntlProvider>
    );
    tracking.trackPageview();
});
